module.exports = __webpack_public_path__ + "static/media/3_3.ca24377e.jpg";